import WarningAmberOutlined from "@mui/icons-material/WarningAmberOutlined";
import { Box, Typography } from "@mui/material";

import type { Section12PaymentRequestWithDetails } from "@thalamos/aspire-common";

import { getS12AccreditationStatus } from "./payment-request-helpers.js";

interface Section12AccreditationBadgeProps {
  request: Section12PaymentRequestWithDetails;
}

export function Section12AccreditationBadge({
  request,
}: Section12AccreditationBadgeProps) {
  const status = getS12AccreditationStatus(request.doctor?.section12ExpiryDate);

  if (!status) {
    return (
      <Typography component="span" variant="body2">
        —
      </Typography>
    );
  }

  if (status === "accredited") {
    return (
      <Typography component="span" variant="body2">
        accredited
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        color: "warning.dark",
      }}
    >
      <WarningAmberOutlined fontSize="small" />
      <Typography component="span" variant="body2">
        expired
      </Typography>
    </Box>
  );
}
